module.exports = __webpack_public_path__ + "img/oglethorpedininghall-h-474x356.40e4e8d6.jpg";